const KEYS = {
  PAPER_WIDTH: 'printerPaperWidth',
  AUTO_PRINT: 'printerAutoPrint',
};

export const PAPER_WIDTH_OPTIONS = [
  { label: '80mm (มาตรฐาน)', value: '80mm' },
  { label: '58mm (เล็ก)', value: '58mm' },
];

export const getPaperWidth = () => {
  return localStorage.getItem(KEYS.PAPER_WIDTH) || '80mm';
};

export const setPaperWidth = (width) => {
  localStorage.setItem(KEYS.PAPER_WIDTH, width);
};

export const getAutoPrint = () => {
  const stored = localStorage.getItem(KEYS.AUTO_PRINT);
  return stored === null ? true : stored === 'true';
};

export const setAutoPrint = (value) => {
  localStorage.setItem(KEYS.AUTO_PRINT, String(value));
};

export const applyPrinterPageStyle = () => {
  const width = getPaperWidth();
  let styleEl = document.getElementById('printer-page-style');
  if (!styleEl) {
    styleEl = document.createElement('style');
    styleEl.id = 'printer-page-style';
    document.head.appendChild(styleEl);
  }
  styleEl.textContent = `@page { size: ${width} auto; margin: 0; }`;
};
